import type { ApplicationFlag } from "~/types/storyblok/storyblok";

export const useApplicationFlags = ({
	appFlags,
	productFlags,
	offsetStartByPlacement
}: {
	appFlags: ApplicationFlag[];
	productFlags: string[];
	offsetStartByPlacement?: Record<string, number>;
}) => {
	const getFlagData = (flagId: string) => {
		return appFlags.find((f) => f.id === flagId);
	};
	const getItemPosition = (flagId: string, index: number | string) => {
		const flag = getFlagData(flagId);
		const yOffsetStep = 9;

		if (!flag) {
			return "top-2 left-0";
		}

		const [yRule, xRule] = flag.placement.split(",");
		const yOffsetStart = offsetStartByPlacement?.[yRule] ?? 2;

		const samePlacementCount = [...productFlags]
			.slice(0, Number(index))
			.filter((id) => getFlagData(id)?.placement === flag.placement).length;

		return `${xRule}-0 ${yRule}-${yOffsetStart + samePlacementCount * yOffsetStep}`;
	};

	return { getItemPosition, getFlagData };
};
